import React, { Fragment } from 'react';
import { bool, func, string } from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import classNames from 'classnames';
import {
  FieldSelect,
  FieldStepperEditable, FieldTextInput,
  Form,
  Modal,
  PrimaryButton,
  SecondaryButton,
} from '../../components';

import css from './styles.css';
import { Form as FinalForm } from 'react-final-form';
import { required } from '../../util/validators';
import { map } from 'ramda';
import {
  getCancelByProviderReasons,
  getDeclineReasons,
} from '../../marketplace-custom-config';

const CancelBookingModal = props => {
  const {
    className,
    rootClassName,
    isProvider,
    id,
    idDescriptionText,
    intl,
    isOpen,
    onOkModal,
    onCloseModal,
    onManageDisableScrolling,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const closeButtonMessage = intl.formatMessage({ id: 'Actions.cancel' });
  const requiredMessage = intl.formatMessage({ id: 'Marketplace.requiredMessage' });
  const selectPlaceholder = intl.formatMessage({ id: 'EditListingInformationForm.selectPlaceholder' });
  const onSubmit = (values) => {
    console.log('onSubmit', values);
    const { reason, reasonDetails } = values
    onOkModal({
      reason,
      reasonDetails
    });
  };

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      closeButtonMessage={closeButtonMessage}
    >
      <p className={css.modalTitle}>
        <FormattedMessage id="CancelBookingModal.title" />
      </p>
      <p className={css.modalMessage}>
        <FormattedMessage id={idDescriptionText} />
      </p>
      <FinalForm
        initialValues={{}}
        onSubmit={(values) => onSubmit(values)}
        render={formRenderProps => {
          const {
            active,
            form,
            handleSubmit,
            values,
          } = formRenderProps;
          return (
            <Fragment>
              <Form id="bookingForm" onSubmit={handleSubmit} className={css.reasonForm}>
                <FieldSelect
                  className={css.reasonChoice}
                  id="reason"
                  name="reason"
                  label={intl.formatMessage({ id: 'TransactionPanel.cancelReason' })}
                  validate={required(requiredMessage)}
                >
                  <option value="">{selectPlaceholder}</option>
                  {map(({ label, key }) => (
                    <option value={key}>{label}</option>
                  ), isProvider ? getCancelByProviderReasons(intl) : getDeclineReasons(intl))}
                </FieldSelect>
                {values.reason === 'other' && (
                  <FieldTextInput
                    id="reasonDetails"
                    name="reasonDetails"
                    validate={required(requiredMessage)}
                    type="textarea"
                    label={intl.formatMessage({ id: 'TransactionPanel.cancelReasonDetails' })}
                    placeholder="..."
                  />
                )}
                <SecondaryButton
                  className={css.modalButtonOk}
                  type={'submit'}
                >
                  <FormattedMessage id="TransactionPanel.confirmCancelation" />
                </SecondaryButton>
              </Form>
            </Fragment>
          );
        }}
      />
      {/*<SecondaryButton className={css.modalButtonOk} onClick={onOkModal}>*/}
      {/*  <FormattedMessage id="TransactionPanel.confirmCancelation" />*/}
      {/*</SecondaryButton>*/}
    </Modal>
  );
};

CancelBookingModal.defaultProps = {
  className: null,
  rootClassName: null,
  id: null,
  idDescriptionText: null,
  isOpen: false,
  isProvider: false,
  onOkModal: Function.prototype,
  onCloseModal: Function.prototype,
};

CancelBookingModal.propTypes = {
  className: string,
  rootClassName: string,
  isProvider: bool,
  id: string,
  idDescriptionText: string,
  isOpen: bool,
  onOkModal: func,
  onCloseModal: func,
  intl: intlShape.isRequired,
};

export default injectIntl(CancelBookingModal);
